import { BspService } from './net-remit/bsp.service';
import { EtlExtractionService } from './net-remit/etl-extraction.service';
import { MacroGroupsService } from './net-remit/macro-groups.service';
import { RemoteUseTypeService } from './net-remit/remoteusetype.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdministrationCleanupService } from "@app/services/net-remit/administration.cleanup.service";
import { AdministrationService } from '@app/services/net-remit/administration.service';
import { CommunicationService } from '@app/services/net-remit/communication.service';
import { CredentialService } from './net-remit/credential.service';
import { ContractManagementService } from './net-remit/contract-management.service';
import { ContractReportService } from '@app/services/net-remit/contract-report.service';
import { CustomerService } from '@app/services/net-remit/customer.service';
import { GraphicService } from '@app/services/net-remit/graphic.service';
import { MaestronetLoginsService } from '@app/services/net-remit/maestronet-logins.service';
import { MaestronetService } from './net-remit/maestronet.service';
import { MixedConditionsService } from './net-remit/mixed-conditions.service';
import { PaymentsService } from '@app/services/net-remit/payments.service';
import { RemoteService } from './net-remit/remote.service';
import { RemoteAccountService } from './net-remit/remote-account.service';
import { ReportService } from '@app/services/net-remit/report.service';
import { SharedDataService } from '@app/services/net-remit/shared-data.service';
import { SharedService } from '@app/services/net-remit/shared-functions.service';
import { TokenService } from '@app/services/net-remit/token.service';
import { UsersService } from '@app/services/net-remit/users.service';
import { ThresholdContractsService } from '@app/services/net-remit/threshold-contracts.service';
import { ThresholdReportService } from '@app/services/net-remit/threshold-report.service';
import { WelcomeMessageService } from './net-remit/welcome-message.service';
import { XmlService } from '@app/services/net-remit/xml.service';
import { TableauService } from './net-remit/tableau.service';
import { TransactionsReportsService } from './net-remit/transaction-reports.service';
import { GroupsFilesService } from '@app/services/net-remit/groups-files.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],

 providers: [
  UsersService,
  TokenService,
  MaestronetLoginsService,
  CommunicationService,
  CredentialService,
  CustomerService,
  GraphicService,
  AdministrationService,
  AdministrationCleanupService,
  SharedService,
  ReportService,
  ContractReportService,
  SharedDataService,
  XmlService,
  PaymentsService,
  RemoteService,
  RemoteUseTypeService,
  RemoteAccountService,
  MacroGroupsService,
  ThresholdContractsService,
  EtlExtractionService,
  ThresholdReportService,
  BspService,
  ContractManagementService,
  MaestronetService,
  MixedConditionsService,
  WelcomeMessageService, 
  TableauService,
  TransactionsReportsService,
  GroupsFilesService
 ]
})
export class ServicesModule {}
